// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__14dxj","notes":"Notes_notes__3dTUK"};